export type SubstitutionStatus = 'pending' | 'approved' | 'rejected'

export interface Substitution {
  id: string
  scenarioId: string
  ingredientKey: string
  ingredientName: string
  ingredientUnit: string
  replacement: string
  reason: string
  startDate: string
  endDate: string
  status: SubstitutionStatus
  rejectionReason?: string
  submittedAt: string
  resolvedAt?: string
}

export interface NewSubstitutionInput {
  scenarioId: string
  ingredientKey: string
  ingredientName: string
  ingredientUnit: string
  replacement: string
  reason: string
  startDate: string
  endDate: string
}

export function ingredientKeyFor(name: string, unit: string): string {
  return `${name.toLowerCase()}|${unit.toLowerCase()}`
}
